<template>
  <div class="nodata-content">
    <img class="nomsg-img" :src="nodata" mode="widthFix" />
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import nodata from "@/assets/images/nodata.png"
export default {
  name: "no-data",
  data: () => {
    return {
      nodata
    };
  }
};
</script>

<style scoped>
.nodata-content {
  text-align: center;
  position: relative;
  padding: 60px 0;
}
.nomsg-img {
  width: 200px;
}
</style>
